module.exports = __webpack_public_path__ + "media/images/welcome-page-image-470f237c.svg";